<template>
  <div class="spacerBar">
    <header class="header">
      <h1 class="title">交直流共塔线路智能间隔棒监测系统</h1>
      <div class="datetime">
        <span>{{ currentDate }}</span>
        <span>{{ weekDay }}</span>
        <span>{{ currentTime }}</span>
      </div>
    </header>
    <span class="location">当前位置：扬镇交直流共塔线路</span>
    <div class="spacerBar__content">
      <div class="top">
        <div class="top__left">
          <div class="tower top_tower dc_tower1" :class="{ offline_tower: !towerInfo['DC001'] }">
            <img
              src="./img/alarm.png"
              class="alarm_icon"
              v-if="towerInfo['DC001'] && towerInfo['DC001'].deviceStatus == 1"
            />
            <div
              class="tower__img"
              :class="{ alarm_img: towerInfo['DC001'] && towerInfo['DC001'].deviceStatus == 1 }"
            >
              <img src="./img/icon.png" class="tower__icon" />
            </div>
            <span class="tower__name" @click="openModal(towerInfo['DC001'])">DC001</span>
          </div>
          <div class="tower top_tower dc_tower2" :class="{ offline_tower: !towerInfo['DC002'] }">
            <img
              src="./img/alarm.png"
              class="alarm_icon"
              v-if="towerInfo['DC002'] && towerInfo['DC002'].deviceStatus == 1"
            />
            <div
              class="tower__img"
              :class="{ alarm_img: towerInfo['DC002'] && towerInfo['DC002'].deviceStatus == 1 }"
            >
              <img src="./img/icon.png" class="tower__icon" />
            </div>
            <span class="tower__name" @click="openModal(towerInfo['DC002'])">DC002</span>
          </div>
          <div class="tower top_tower dc_tower3" :class="{ offline_tower: !towerInfo['DC003'] }">
            <img
              src="./img/alarm.png"
              class="alarm_icon"
              v-if="towerInfo['DC003'] && towerInfo['DC003'].deviceStatus == 1"
            />
            <div
              class="tower__img"
              :class="{ alarm_img: towerInfo['DC003'] && towerInfo['DC003'].deviceStatus == 1 }"
            >
              <img src="./img/icon.png" class="tower__icon" />
            </div>
            <span class="tower__name" @click="openModal(towerInfo['DC003'])">DC003</span>
          </div>
          <div class="tower bottom_tower ac_tower1" :class="{ offline_tower: !towerInfo['AC001'] }">
            <img
              src="./img/alarm.png"
              class="alarm_icon"
              v-if="towerInfo['AC001'] && towerInfo['AC001'].deviceStatus == 1"
            />
            <div
              class="tower__img"
              :class="{ alarm_img: towerInfo['AC001'] && towerInfo['AC001'].deviceStatus == 1 }"
            >
              <img src="./img/icon.png" class="tower__icon" />
            </div>
            <span class="tower__name" @click="openModal(towerInfo['AC001'])">AC001</span>
          </div>
          <div class="tower bottom_tower ac_tower2" :class="{ offline_tower: !towerInfo['AC002'] }">
            <img
              src="./img/alarm.png"
              class="alarm_icon"
              v-if="towerInfo['AC002'] && towerInfo['AC002'].deviceStatus == 1"
            />
            <div
              class="tower__img"
              :class="{ alarm_img: towerInfo['AC002'] && towerInfo['AC002'].deviceStatus == 1 }"
            >
              <img src="./img/icon.png" class="tower__icon" />
            </div>
            <span class="tower__name" @click="openModal(towerInfo['AC002'])">AC002</span>
          </div>
          <div class="tower bottom_tower ac_tower3" :class="{ offline_tower: !towerInfo['AC003'] }">
            <img
              src="./img/alarm.png"
              class="alarm_icon"
              v-if="towerInfo['AC003'] && towerInfo['AC003'].deviceStatus == 1"
            />
            <div
              class="tower__img"
              :class="{ alarm_img: towerInfo['AC003'] && towerInfo['AC003'].deviceStatus == 1 }"
            >
              <img src="./img/icon.png" class="tower__icon" />
            </div>
            <span class="tower__name" @click="openModal(towerInfo['AC003'])">AC003</span>
          </div>
        </div>
        <deviceInfo></deviceInfo>
      </div>
      <div class="bottom">
        <relaMonitor></relaMonitor>
        <lineAlarm></lineAlarm>
        <deviceAlarm></deviceAlarm>
      </div>
    </div>
    <infoModal :visible.sync="showModal" :deviceCode="deviceCode"></infoModal>
    <div v-if="!showMarkUnfold" class="mark-fold" @mouseenter="showMarkUnfold = true">
      <span>管理台</span>
      <img src="./img/left_arrow.png" />
    </div>
    <div v-else class="mark-unfold" @mouseleave="showMarkUnfold = false" @click="openPlatform">
      <img src="./img/marks.png" />
      <span>管理台</span>
    </div>
  </div>
</template>

<script>
  import { date } from 'utils'
  import commonHeader from './commonHeader.vue'
  import deviceInfo from './components/deviceInfo'
  import relaMonitor from './components/relaMonitor'
  import lineAlarm from './components/lineAlarm'
  import deviceAlarm from './components/deviceAlarm'
  import infoModal from './components/infoModal'
  export default {
    components: {
      commonHeader,
      relaMonitor,
      lineAlarm,
      deviceAlarm,
      deviceInfo,
      infoModal
    },
    data() {
      return {
        currentTime: '',
        currentDate: '',
        weekDay: '',
        timer: null,
        isFullScreen: false,
        showModal: false,
        towerInfo: {},
        deviceCode: '',
        showMarkUnfold: false,
        refreshTimer: null
      }
    },
    created() {
      // 监听全屏变化
      this.setupFullscreenListeners()
    },
    mounted() {
      this.enterfullscreen()
      this.initDateTime()
      this.getInfoData()
      this.refreshData()
    },
    methods: {
      openPlatform() {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
        this.$router.push({ name: 'home' })
      },
      refreshData() {
        if (this.refreshTimer) {
          clearInterval(this.refreshTimer)
        }
        this.refreshTimer = setInterval(() => {
          this.getInfoData()
        }, 1000 * 60 * 5)
      },
      // 初始化日期时间
      initDateTime() {
        let dates = date(new Date())
        this.currentDate = [dates.YY, dates.MM, dates.DD].join('-')
        let times = date(new Date())
        this.currentTime = [times.hh, times.mm, times.ss].join(':')
        this.timer = setInterval(() => {
          let times = date(new Date())
          this.currentTime = [times.hh, times.mm, times.ss].join(':')
        }, 1000)
        this.weekDay = '星期' + '日一二三四五六'.charAt(new Date().getDay())
      },
      // 设置全屏监听器
      setupFullscreenListeners() {
        let isFullScreen =
          document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.fullScreen ||
          document.mozFullScreen ||
          document.webkitIsFullScreen
        isFullScreen = !!isFullScreen

        const fullscreenChangeHandler = () => {
          this.isFullScreen = !isFullScreen
        }

        document.addEventListener('fullscreenchange', fullscreenChangeHandler)
        document.addEventListener('mozfullscreenchange', fullscreenChangeHandler)
        document.addEventListener('webkitfullscreenchange', fullscreenChangeHandler)
        document.addEventListener('msfullscreenchange', fullscreenChangeHandler)
      },

      //进入全屏
      enterfullscreen() {
        let docElm = document.documentElement
        if (!this.isFullScreen) {
          if (docElm.requestFullscreen) {
            docElm.requestFullscreen()
          } else if (docElm.mozRequestFullScreen) {
            docElm.mozRequestFullScreen()
          } else if (docElm.webkitRequestFullScreen) {
            docElm.webkitRequestFullScreen()
          } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen()
          }
        }
      },

      // 返回首页
      backHome() {
        this.exitFullscreen()
        this.$router.push({ name: 'home' })
      },

      // 退出全屏
      exitFullscreen() {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      },
      getInfoData() {
        this.$axiosget('operation/gapStick/getSimpleData').then(res => {
          if (res.data.status == 10000) {
            this.towerInfo = res.data.data
          }
        })
      },

      openModal(item) {
        if (!item) return
        this.deviceCode = item.deviceId
        this.showModal = true
      }
    },
    beforeDestroy() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer)
      }
      if (this.timer) {
        clearInterval(this.timer)
      }
    }
  }
</script>

<style lang="less">
  html::-webkit-scrollbar {
    width: 0;
  }
</style>

<style lang="less" scoped>
  .bg(@img) {
    background: url('./img/@{img}');
    background-size: 100% 100%;
    background-color: transparent;
    background-repeat: no-repeat;
  }
  .spacerBar {
    height: 100%;
    background: url('./img/bg.png');
    background-size: 100% 100%;
    background-color: transparent;
    position: relative;

    & > header {
      height: 8.06vh;
      text-align: center;
      position: relative;

      .title {
        padding-top: 1.4vh;
        font-family: 'Alibaba-PuHuiTi-H';
        font-size: 3.34vh;
        font-weight: 600;
        letter-spacing: 1;
        background: linear-gradient(180deg, #fff 50%, #1594ff);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      .datetime {
        position: absolute;
        top: 1.07vh;
        right: 0.25rem;
        color: rgba(255, 255, 255, 0.8);
        font-family: 'MicrosoftYaHei-Bold';
        font-size: 1.3vh;
        font-weight: bold;

        span:nth-child(2) {
          margin: 0 0.12rem;
        }
      }
    }

    .location {
      margin-left: 0.39rem;
      font-family: MicrosoftYaHei;
      font-size: 1.3vh;
      line-height: 1.07;
      color: #ffffff;
    }

    .spacerBar__content {
      margin-top: 3vh;
      height: calc(100% - 8.06vh - 3vh - 1.1vh - 5.2vh);
      padding: 0 0.24rem;

      .top {
        height: calc(100% - 32.81vh - 2.32vh);
        display: flex;

        &__left {
          width: calc(100% - 6.07rem - 0.24rem);
          height: 100%;
          .bg('maps.png');
          position: relative;

          .tower {
            position: absolute;
            display: flex;
            flex-direction: column;
            z-index: 2;
            .tower__img {
              width: 0.72rem;
              height: 6.67vh;
              .bg('mark.png');
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0;

              .tower__icon {
                width: 0.63rem;
                height: auto;
              }
            }

            .alarm_icon {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              top: -1.58vh;
              width: 0.38rem;
              height: auto;
            }

            .alarm_img {
              .bg('mark_alarm.png');
            }

            .tower__name {
              margin-top: 0.56vh;
              display: inline-flex;
              justify-content: center;
              align-items: center;
              width: 0.72rem;
              height: 1.85vh;
              border-radius: 0.05rem;
              border: 0.02rem solid #37e3f5;
              font-family: 'MicrosoftYaHei';
              font-size: 1.48vh;
              font-weight: bold;
              color: #3fd9ff;
              cursor: pointer;
            }
          }

          .offline_tower {
            .tower__img {
              .bg('offline_mark.png');
            }

            .tower__name {
              border-color: #a1a1a1;
              color: #adadad;
            }
          }

          .top_tower {
            top: 7.04vh;
          }

          .bottom_tower {
            top: 18.35vh;
          }

          .dc_tower1 {
            left: 3.52rem;
          }

          .dc_tower2 {
            left: 5.8rem;
          }

          .dc_tower3 {
            left: 8.1rem;
          }

          .ac_tower1 {
            left: 3.52rem;
          }

          .ac_tower2 {
            left: 5.8rem;
            top: 18.63vh;
          }

          .ac_tower3 {
            left: 8.1rem;
          }
        }

        & > div:nth-child(2) {
          margin-left: 0.24rem;
          width: 6.07rem;
          height: 100%;
          .bg('statis.png');
        }
      }

      .bottom {
        margin-top: 2.32vh;
        height: 32.81vh;
        display: flex;
        justify-content: space-between;
        align-items: center;

        & > section {
          width: calc((100% - 0.24rem * 2) / 3);
          height: 100%;
          .bg('section_bg.png');
          position: relative;

          &:nth-child(2) {
            margin: 0 0.24rem;
          }
        }
      }
    }

    .mark-fold {
      position: fixed;
      top: 6.67vh;
      right: 0;
      width: 0.24rem;
      height: 12.05vh;
      background-image: url('./img/fold_bg.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s;

      span {
        text-align: center;
        display: inline-block;
        font-family: 'FZLTZHK--GBK1-0';
        font-size: 1.3vh;
        color: #fff;
      }
    }

    .mark-unfold {
      position: absolute;
      right: 0;
      top: 6.67vh;
      width: 1.27rem;
      height: 12.14vh;
      background-image: url('./img/unfold_bg.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all 0.3s;

      img {
        position: absolute;
        top: 1.2vh;
        left: 50%;
        transform: translateX(-50%);
        width: 1.01rem;
        height: auto;
      }

      span {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        display: inline-block;
        height: 3.98vh;
        line-height: 3.98vh;
        background-image: url('./img/unfold_name.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        text-align: center;
        font-family: 'FZLTZHK--GBK1-0';
        font-size: 1.48vh;
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/spacerBar/index.vue